<template>
  <div>
    <v-btn x-small rounded :color="getThemeColor" dark @click="openDialog()" v-if="isManager">
      <v-icon>mdi-plus</v-icon>
    </v-btn>

    <v-dialog v-model="dialog" width="600" persistent>
      <v-card>
        <v-card-title
          :style="{'background-color':getThemeColor,'color':'white'}"
          class="headline lighten-2"
        >Create Service Provider</v-card-title>
        <v-text-field class="mx-10" v-model="companyName" label="Company Name"></v-text-field>
        <v-text-field class="mx-10" v-model="representative" label="Representative"></v-text-field>
        <v-text-field class="mx-10" v-model="address" label="Address"></v-text-field>
        <v-text-field class="mx-10" v-model="phone" label="Phone"></v-text-field>
        <v-text-field class="mx-10" v-model="email" label="Email"></v-text-field>
        <v-text-field class="mx-10" v-model="city" label="City"></v-text-field>
        <v-text-field class="mx-10" v-model="code" label="Postal Code"></v-text-field>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn rounded color="primary" dark @click="closeDialog()">Cancel</v-btn>
          <v-btn rounded color="error" dark @click="createServiceProviderNow()">Create Now</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "@/plugins/axios";

export default {
  computed: {
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
    isManager() {
      return this.$store.getters.isManager;
    }
  },
  data() {
    return {
      dialog: false,
      companyName: "General Service Provider",
      representative: "General Manager",
      address: "123 Street",
      phone: "076 123 4567",
      email: "provider@service.com",
      city: "Durban",
      code: "4001"
    };
  },
  methods: {
    openDialog() {
      this.dialog = true;
    },
    closeDialog() {
      this.dialog = false;
    },
    createServiceProviderNow() {
      if (this.companyName == null) {
        alert("Company Name is Required !!");
        return false;
      } else {
        this.$store.commit("setLoader", true);
        axios
          .postDataWithToken(
            "/auth/create-service-provider",
            {
              companyName: this.companyName,
              representative: this.representative,
              address: this.address,
              phone: this.phone,
              email: this.email,
              city: this.city,
              code: this.code
            },
            this.getAccessToken
          )
          .then(serviceProviders => {
            this.$store.commit("setServiceProviders", serviceProviders);
            this.$store.commit("setLoader", false);
            this.closeDialog();
          });
      }
    }
  }
};
</script>

<style>
</style>